var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import ErrorHandler from '@/support/ErrorHandler';
import { ucstring } from '@/support/String';
import { Group } from '@/models/Group';
import { RolesEnum } from '@/items/Roles';
let Notes = class Notes extends Vue {
    constructor() {
        super(...arguments);
        this.content = '';
        this.disableEditor = false;
        this.editorOptions = {
            modules: {
                toolbar: this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]) ? true : false,
                magicUrl: true,
            },
        };
    }
    mounted() {
        if (this.group.type && typeof this.group.type !== 'string' && this.group.type.label === 'parnassys') {
            this.$router.go(-1);
            return;
        }
        this.content = this.group.notes || '';
        this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]) ? this.disableEditor = false : this.disableEditor = true;
    }
    onEditorBlur(quill) {
        //
    }
    onEditorFocus(quill) {
        //
    }
    onEditorReady(quill) {
        //
    }
    onEditorChange(quill, html, text) {
        this.content = html;
    }
    save() {
        this.group
            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent'])
            .update({ notes: this.content })
            .then(() => {
            this.group.notes = this.content;
            this.$emit('update', this.group);
            this.$store.dispatch('openDialog', this.dialogOptions);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: ucstring(this.$t('dialogOptions.save', { item: this.$t('dialogOptions.item.note') }).toString()),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER]);
    }
};
__decorate([
    Model('group'),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Notes.prototype, "group", void 0);
Notes = __decorate([
    Component({
        components: {
            quillEditor,
        },
    })
], Notes);
export default Notes;
